export const confirmDelete = (message) => {
    return window.confirm(message);
};

export const confirmModal = (message) => {
    return window.confirm(message);
};